<template>
    <div class="mt-4 py-4 border-t">
        <div class="flex flex-wrap pasItems-center mb-2 pb-4 border-b">
            <span class="text-uppercase font-bold mr-2 mt-2 text-sm">Trade Tracker's Category:</span>
            <div class="inline-block mt-0 sm:mt-1 xs:w-full">
                <select @change="onChangeCategory" v-model="currentCategory" class="form-control form-control-sm form-control-inline align-bottom bg-white">
                    <template v-for="category in pasCategories">
                    <option v-if="category.active" :value="category">{{ category.name }}</option>
                    </template>
                </select>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-hover border border-t-0 admin-table">
                <thead>
                    <tr>
                        <th><span class="text-xs">PBL</span></th>
                        <th><span class="text-xs">Contract</span></th>
                        <th><span class="text-xs">ID</span></th>
                        <th><span class="text-xs">Qty</span></th>
                        <th><span class="text-xs">Dir</span></th>
                        <th><span class="text-xs">Strategy</span></th>
                        <th><span class="text-xs">Entry Date</span></th>
                        <th><span class="text-xs">Entry Price</span></th>
                        <th><span class="text-xs">Stop Loss</span></th>
                        <th><span class="text-xs">Target Price</span></th>
                        <th><span class="text-xs">Exit Date</span></th>
                        <th><span class="text-xs">Exit Price</span></th>
                        <th><span class="text-xs">Closed P/L</span></th>
                        <th class="text-center"><span class="text-xs">Actions</span></th>
                    </tr>
                </thead>

                <tbody>
                    <template v-for="(pasItem) in pasData" v-if="pasData.length > 0" :key="pasItem.id">
                        <tr :class="(!pasItem.exit_date) ? 'bg-yellow-100' : ' bg-white'">
                            <td>
                                <i @click="togglePublic(pasItem, false)" class="fas fa-toggle-on text-blue-500 text-xl cursor-pointer" v-tooltip="{ content: 'Make NON-PUBLIC', placement: 'auto-start', theme: 'red' }" v-if="pasItem.public"></i>
                                <i @click="togglePublic(pasItem, true)" class="fas fa-toggle-off text-gray-500 text-xl cursor-pointer" v-tooltip="{ content: 'Make PUBLIC', placement: 'auto-start', theme: 'info' }" v-else></i>
                            </td>
                            <td><span class="text-xs">{{ pasItem.contract_name || '-' }}</span></td>
                            <td><span class="text-xs">{{ pasItem.id || '-' }}</span></td>
                            <td><span class="text-xs">{{ pasItem.quantity || '-' }}</span></td>
                            <td><span class="text-xs">{{ pasItem.direction || '-' }}</span></td>
                            <td><span class="text-xs">{{ pasItem.strategy || '-' }}</span></td>
                            <td><span class="text-xs">{{ pasItem.entry_date || '-' }}</span></td>
                            <td><span class="text-xs">{{ pasItem.formattedEntryPrice || '-' }}</span></td>
                            <td><span class="text-xs">{{ pasItem.stop_loss || '-' }}</span></td>
                            <td><span class="text-xs">{{ pasItem.target_price || '-' }}</span></td>
                            <td><span class="text-xs">{{ pasItem.exit_date || '-' }}</span></td>
                            <td><span class="text-xs">{{ pasItem.formattedExitPrice || '-' }}</span></td>
                            <td><span class="text-xs">{{ pasItem.closed_profit_loss || '-' }}</span></td>
                            <td class="text-center">
                                <div class="flex">
                                    <a :href="getEditLink(pasItem)" v-tooltip="{ content: 'Edit Current Alert', placement: 'auto-start', theme: 'info' }" class="text-xs text-blue-500 mr-0 sm:mr-3 inline-block">
                                        <i class="far fa-edit"></i>
                                    </a>
                                    <button @click="moveTradeTrackerModal = pasItem" class="text-xs text-blue-500 inline-block mr-0 sm:mr-3" v-tooltip="{ content: 'Move Current Alert', placement: 'auto-start', theme: 'blue' }">
                                        <i class="fas fa-exchange-alt"></i>
                                    </button>
                                    <button @click="deleteTradeTrackerModal = pasItem" class="text-xs text-red-500 inline-block" v-tooltip="{ content: 'Delete Current Alert', placement: 'auto-start', theme: 'red' }"><i class="fas fa-times"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

        <modal @close="moveTradeTrackerModal = null" v-if="moveTradeTrackerModal" className="max-w-sm w-full">
            <template #header>
                <div class="text-blue-500">
                    <i class="fas fa-exclamation-circle mr-1"></i>
                    Move Alert
                </div>
            </template>
            <template #body>
                <div class="pt-4 pb-2">
                    <div class="w-full bg-tan-200 text-center py-2 px-1 border mb-2 border-gray-200">
                        <p class="text-md font-bold leading-none text-blue-500">{{ moveTradeTrackerModal.contract_name }}</p>
                    </div>
                    <div class="w-full pb-2">
                        <label for="selectedCategory">Move To Category</label>
                        <select @focus="moveTradeTrackerModalError=''" v-model="moveTradeTrackerCategory" class="form-control form-control-sm form-input-modal" id="selectedCategory">
                            <option value="">Select Category....</option>
                            <option :value="category" v-for="category in pasCategories" :disabled="category.id == currentCategory.id">{{ category.name }}</option>
                        </select>
                    </div>
                    <div class="w-full p-0 mb-3 bg-red-500 px-2 py-1 text-white text-xs text-center" v-if="moveTradeTrackerModalError">
                        {{ moveTradeTrackerModalError }}
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex justify-center">
                    <div class="btn btn-sm btn-blue-ghost inline-flex mx-1" @click="moveTradeTrackerModal = null">Cancel</div>
                    <div class="btn btn-sm btn-blue-500 inline-flex mx-1" @click="moveTradeTracker(moveTradeTrackerModal)">Move</div>
                </div>
            </template>
        </modal>

        <modal @close="deleteTradeTrackerModal = null" v-if="deleteTradeTrackerModal" className="max-w-sm w-full">
            <template #header>
                <div class="text-red-500">
                    <i class="fas fa-exclamation-circle mr-1"></i>
                    Delete Alert?
                </div>
            </template>
            <template #body>
                <div class="pt-4 pb-2">
                    <div class="mb-3">
                        <p><strong>Are you sure you want to Delete Alert?</strong></p>
                        <p class="mt-2">Changes can not be undone.</p>
                    </div>
                    <div class="w-full p-0 mb-3 bg-red-500 px-2 py-1 text-white text-xs text-center" v-if="deleteTradeTrackerModalError">
                        {{ deleteTradeTrackerModalError }}
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex justify-center">
                    <div class="btn btn-sm btn-red-ghost inline-flex mx-1" @click="deleteTradeTrackerModal = null">Cancel</div>
                    <div class="btn btn-sm btn-red inline-flex mx-1" @click="deleteTradeTracker(deleteTradeTrackerModal)">Delete Alert</div>
                </div>
            </template>
        </modal>

        <flash-message ref="flash" :seconds-to-display="6"></flash-message>

    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    initialValues: {
        type: [Object, Array],
        default: () => ({}),
        required: false
    },
    pasCategories: {
        type: [Object, Array],
        required: false
    }
});

const flash = ref(null);
const pasData = ref(props.initialValues || []);
const currentCategory = ref(props.pasCategories[0] || {});

const moveTradeTrackerModal = ref(null);
const moveTradeTrackerCategory = ref('');
const moveTradeTrackerModalError = ref('');

const deleteTradeTrackerModal = ref(null);
const deleteTradeTrackerModalError = ref('');

function togglePublic(item, publicValue) {
    const route = window.route('admin.jims-trade-tracker.public', { jims_trade_tracker: item });
    axios.post(route, {
        public: publicValue
    })
        .then((response) => {
            flash.value.display('Successfully changed «Public» status!');
            item.public = publicValue;
        }).catch((error) => {
            if (error && error.response.data.message) {
                moveTradeTrackerModalError.value = error.response.data.message;
            } else {
                moveTradeTrackerModalError.value = 'Something went wrong, please try again later';
            }
            console.error(error);
        });
}

function onChangeCategory() {
    pasData.value = [];
    const route = window.route('admin.jims-trade-tracker.index');
    axios.get(route, {
        params: {
            category: currentCategory.value.id
        }
    })
        .then((response) => {
            if (response.data && response.data.pasData && response.data.pasData.length > 0) {
                pasData.value = response.data.pasData;
            } else {
                pasData.value = [];
            }
        }).catch((error) => {
            console.error(error);
        });
}

function moveTradeTracker(item) {
    if (moveTradeTrackerCategory.value === '') {
        moveTradeTrackerModalError.value = 'Please select the category and try again';
        return;
    }

    const route = window.route('admin.jims-trade-tracker.move', { jims_trade_tracker: item, category: moveTradeTrackerCategory.value.id });
    axios.patch(route)
        .then((response) => {
            moveTradeTrackerModal.value = false;
            if (currentCategory.value.id != response.data.pasData.category_id) {
                pasData.value = pasData.value.filter(pas => pas.id !== item.id)
            }
            moveTradeTrackerCategory.value = '';
            flash.value.display('Successfully moved «Jim\'s Trade Tracker» entry!');
        }).catch((error) => {
            if (error && error.response.data.message) {
                moveTradeTrackerModalError.value = error.response.data.message;
            } else {
                moveTradeTrackerModalError.value = 'Error. Something went wrong, please try again later';
            }
            console.error(error);
        });
}

function deleteTradeTracker(item) {
    const route = window.route('admin.jims-trade-tracker.destroy', { jims_trade_tracker: item });
    axios.delete(route)
        .then((response) => {
            deleteTradeTrackerModal.value = false;
            const index = pasData.value.map(d => d.id).indexOf(item.id);
            pasData.value.splice(index, 1);
            flash.value.display('Successfully deleted «Jim\'s Trade Tracker» entry!');
        }).catch((error) => {
            if (error && error.response.data.message) {
                deleteTradeTrackerModalError.value = error.response.data.message;
            } else {
                deleteTradeTrackerModalError.value = 'Error. Something went wrong, please try again later';
            }
            console.error(error);
        });
}

function getEditLink(pasItem) {
    return window.route('admin.jims-trade-tracker.edit', { 'jims_trade_tracker': pasItem });
}

// function getCloseLink(pasItem) {
//     //'Are you sure you want to Close Alert?'
//     return window.route('admin.jims-trade-tracker.close', { 'jims_trade_tracker': pasItem });
// }

// function geDeleteLink(pasItem) {
//     //Are you sure you want to Delete Alert?
//     return window.route('admin.jims-trade-tracker.destroy', { 'jims_trade_tracker': pasItem });
// }
</script>
